
<div class="ac-color animated {{options.stepDirectionClass}}" style="padding:1rem;">
    <!--START PARTIAL AMOUNT-->
    <div class="my-panel mb-1 no-shadow">
        <div class="my-panel-body">
            <div class="_panel-title"><div>{{'partial_payment_title' | translate}}</div></div>
            <div class="partial-amount-display">
                <div class="_inner" (click)="setSplitPaymentOption(manualPartial)">
                    <div class="edit btn-bordered-image _only mr-3">
                        <div class="image-icon-badge"><mat-icon svgIcon="pen"></mat-icon></div>
                    </div>
                    <div class="_val">{{partialPayment.amount | lcurrency}}</div>
                    <div class="_spacer"></div>
                </div>
            </div>
            <div class="pmamount-rows">
                <button type="button" class="btn-bordered"
                        *ngFor="let opt of splitPaymentOptions"
                        [ngClass]="{'active': opt.isText || opt === partialPayment}"
                        (click)="setSplitPaymentOption(opt)"
                        [disabled]="opt.disabled">
                    <div>
                        <div [ngClass]="{'text-xs': opt.isText}">{{opt.text}}</div>
                        <div class="text-xs" *ngIf="!opt.isManual">{{opt.subText | lcurrency:currencyFormat}}</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <!--END PARTIAL AMOUNT-->
    <!--START OTHER METHODS-->
    <div class="my-panel mb-base no-shadow" *ngIf="appService.regionArgs.enableByItems && !$storage.check">
        <div class="my-panel-body">
            <!--<div class="_panel-title"><div>{{'partial_payment_calcs_title' | translate}}</div></div>-->
            <div class="pmamount-rows">
                <button type="button" class="btn-bordered-image text-base" (click)="payByOffers()" style="width:50%">
                    <div class="image-icon-badge mr-2"><mat-icon svgIcon="list_check"></mat-icon></div>
                    <div>{{'pay_by_items' | translate}}</div>
                </button>
                <button type="button" class="btn-bordered-image text-base" (click)="payByDiners()" style="width:50%">
                    <div class="image-icon-badge mr-2"><mat-icon svgIcon="users"></mat-icon></div>
                    <div>{{'pay_by_diners' | translate}}</div>
                </button>
            </div>
        </div>
    </div>
    <!--END OTHER METHODS-->
    <!--START GRATUITY-->
    <div class="my-panel no-shadow" *ngIf="$storage.enableGratuity">
        <div class="my-panel-body">
            <div class="_panel-title">
                <div>{{'gratuity' | translate}}</div>
            </div>

            <div class="text-center text-info pb-2 position-relative" style="top:-5px" *ngIf="$storage.order.autoGratuity">
                {{appService.translate('service_charges_applied', {name: $storage.order.autoGratuity.name})}}: {{$storage.order.autoGratuity.amount | lcurrency:'1.2-2'}}
            </div>

            <div class="gratuity-rows">
                <!--SEATED GRATUITY-->
                <ng-container *ngIf="tipBehavior == 'P'">
                    <button type="button" class="btn-bordered"
                            *ngFor="let opt of $storage.gratuities"
                            [ngClass]="{'active': slectedGratuity == opt}"
                            (click)="setGratuity('p', opt)">
                        <div >{{opt}}%</div>
                        <div class="info">{{tabitPayService.calculateGratuityFromPercentage(opt, partialPayment.amount) | lcurrency:currencyFormat}}</div>
                    </button>
                </ng-container>
                <!--end SEATED GRATUITY-->
                <!--COURIER GRATUITY-->
                <ng-container *ngIf="tipBehavior == 'A'">
                    <button type="button" class="btn-bordered"
                            *ngFor="let opt of $storage.gratuities"
                            [ngClass]="{'active': slectedGratuity == opt}"
                            (click)="setFixedValGratuity(opt)">
                        <div >{{opt | lcurrency:'1.0-0'}}</div>
                    </button>
                </ng-container>
                <!--end COURIER GRATUITY-->
            </div>

            <div class="gratuity-rows">
                <button type="button" (click)="setManualGratuity('v')" style="width:25%;" class="btn-bordered" [ngClass]="{'active': slectedGratuity == 'v'}">
                    <span>{{ 'amount' | translate}} {{appService.regionArgs.currency}}</span>
                    <div *ngIf="slectedGratuity == 'v'" class="info _lg">{{gratuity.amount | lcurrency:currencyFormat}}</div>
                </button>
                <button type="button" (click)="setManualGratuity('p')" style="width:25%;" class="btn-bordered" [ngClass]="{'active': slectedGratuity == 'p'}">
                    <span>{{ 'percent' | translate}} %</span>
                    <div *ngIf="slectedGratuity == 'p'" class="info _lg d-flex align-items-center justify-content-center"><span>{{gratuity.percent | number:'1.0-2'}}%</span><span class="ml-2">{{gratuity.amount | lcurrency:currencyFormat}}</span></div>
                </button>
            </div>

            <div *ngIf="gratuity.amount && $storage.gratuityPAWarning" class="mt-1 text-accent text-center font-semi-bold text-xs animated faster slideInUp">
                <div>{{$storage.gratuityPAWarning}}</div>
            </div>
        </div>
    </div>
    <!--END GRATUITY-->


</div>

<div class="ac-color p-3 pb-4 fixed-bottom">
    <button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (click)="submit()">
        <div class="_inner">
            <span>{{"continue" | translate}}</span>
            <b *ngIf="total">{{(partialPayment.amount  + gratuity.amount) | lcurrency}}</b>
            <div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
        </div>
    </button>
</div>
